<template>
  <span :class="
    'xm-button ' +
    ' xm-button-' + type + 
    ' xm-button-' + size +
    (round ? ' xm-button-round' : '') +
    (bordered ? ' xm-button-bordered' : '') +
    (active ? ' active' : '') +
    (disabled ? ' disabled' : '')"
    @click="handleClick">
    <slot></slot>
  </span>
</template>


<script>
export default {
  name: 'xm-button',
  props: {
    type: {
      type: String,
      default: 'default'  // default, light, danger, warning, success
    },
    size: {
      type: String,
      default: 'medium' // small, medium(default), large
    },
    round: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    }
  }
};
</script>

<style lang="less">
@import '../core/variables.less';
@import '../core/mixins.less';

.xm-button {
  color: white;
  border: 0;
  background-color: @color-primary;
  text-decoration: none;
  text-align: center;
  display: block;
  border-radius: 0.08rem;
  line-height: @btn-height;
  box-sizing: border-box;
  appearance: none;
  padding: 0 0.8rem;
  margin: 0;
  height: @btn-height;
  white-space: nowrap;
  position: relative;
  text-overflow:ellipsis;
  font-size: 0.32rem;
  cursor: pointer;
  input[type="submit"]&, input[type="button"]&{
    width: 100%;
  }

  &:active {
    background-color: @color-primary-active;
  }
  &.xm-button-round,
  .xm-button-round & {
    &, &:after {
      border-radius: (@btn-height - 0.1rem);
    }

    &.xm-button-large:after {
      border-radius: (@btn-large-height - 0.1rem);
    }
  }
  &.active {
    &, &:active {
      background-color: @color-primary-active;
    }
  }
  &.xm-button-large,
  .xm-button-large & {
    font-size: 0.32rem;
    height: @btn-large-height;
    line-height: @btn-large-height;
  }
  &.xm-button-small,
  .xm-button-small & {
    padding: 0 0.2rem;
    font-size: 0.32rem;
    display: inline-block;
    height: @btn-small-height;
    line-height: @btn-small-height;
  }
  i.icon {
    &:first-child {
      margin-right: 0.5rem;
    }
    &:last-child {
      margin-left: 0.5rem;
    }
    &:first-child:last-child {
      margin-left: 0;
      margin-right: 0;
    }
  }
}

.xm-button-variant(@color, @color-active) {
  background: @color;
  &:active {
    background: @color-active;
  }
}

.xm-button-light {
  .xm-button-variant(#f7f7f7, #dedede);
  .hairline-border(rgba(0,0,0,.2), .25rem);
  color: #5f646e;
}
.xm-button-dark {
  .xm-button-variant(#6e727b, @color-primary-active);
  color: #5f646e;
}
.xm-button-success {
  .xm-button-variant(@color-success, @color-success-active);
}
.xm-button-danger {
  .xm-button-variant(@color-danger, @color-danger-active);
}
.xm-button-warning {
  .xm-button-variant(@color-warning, @color-warning-active);
}

.xm-button {
  &,
  &.xm-button-light,
  &.xm-button-primary,
  &.xm-button-success,
  &.xm-button-danger,
  &.xm-button-warning {
    &.disabled {
      .hairline-border-remove();
      .xm-button-variant(#c8c9cb, #c8c9cb);
      color: white;
      cursor: not-allowed;
    }
  }
}


.bordered-variant(@color, @color-active) {
  color: @color;
  &:after {
    border-color: @color;
  }
  &:active {
    color: white;
    background-color: @color-active;
    &:after {
      border-color: @color-active;
    }
  }
}

.xm-button.xm-button-bordered,
.xm-button-bordered .xm-button {
  background-color: transparent;
  .hairline-border(@color-primary, .12rem);

  .bordered-variant(@color-primary, @color-primary-active);

  .xm-button-round &,
  &.xm-button-round {
    &:after {
      border-radius: @btn-height;
    }
    &.xm-button-large,
    .xm-button-large & {
      &:after {
        border-radius: @btn-large-height;
      }
    }
  }

  &.xm-button-success {
    .bordered-variant(@color-success, @color-success-active);
  }

  &.xm-button-warning {
    .bordered-variant(@color-warning, @color-warning-active);
  }

  &.xm-button-danger {
    .bordered-variant(@color-danger, @color-danger-active);
  }

  &.disabled,
  &[disabled] {
    color: #c8c9cb;
    background: transparent;
    cursor: not-allowed;
    &:after {
      border-color: #c8c8cb;
    }
    &:active {
      background-color: transparent;
      color: #c8c9cb;
      &:after {
        border-color: #c8c8cb;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Button.vue